module.exports = __webpack_public_path__ + "static/img/news9.6ef46b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/news9.png
// module id = xpfL
// module chunks = 52